type BreakingChangesErrorToastProps = {
  message: string;
  onShowDetails: () => void;
};

export const BreakingChangesErrorToast = ({
  message,
  onShowDetails,
}: BreakingChangesErrorToastProps) => (
  <div className="flex flex-col gap-1">
    <span>{message}</span>
    <button className="text-left text-sm underline" onClick={onShowDetails}>
      Show details
    </button>
  </div>
);
